const colors = {
  colors: {
    green: {
      50: "#F2FFE5",
      100: "#DBFFB8",
      200: "#C4FF8A",
      300: "#ADFF5C",
      400: "#96FF2E",
      500: "#80FF00",
      600: "#66CC00",
      700: "#4D9900",
      800: "#336600",
      900: "#1A3300",
    },
    teal: {
      50: "#EBFAF2",
      100: "#C6F0DA",
      200: "#A2E7C2",
      300: "#7DDEAA",
      400: "#58D592",
      500: "#34CB7A",
      600: "#29A362",
      700: "#1F7A49",
      800: "#155131",
      900: "#0A2918",
    },
    red: {
      50: "#FCE9E8",
      100: "#F7C2BF",
      200: "#F29B96",
      300: "#EE746D",
      400: "#E94D44",
      500: "#E4251B",
      600: "#B61E16",
      700: "#891610",
      800: "#5B0F0B",
      900: "#2E0705",
    },
    yellow: {
      50: "#FFF8E5",
      100: "#FFEBB8",
      200: "#FFDD8A",
      300: "#FFD05C",
      400: "#FFC32E",
      500: "#FFB600",
      600: "#CC9200",
      700: "#996D00",
      800: "#664900",
      900: "#332400",
    },
    blue: {
      50: "#E5F7FF",
      100: "#B8E9FF",
      200: "#8ADBFF",
      300: "#5CCEFF",
      400: "#2EC0FF",
      500: "#00B2FF",
      600: "#008ECC",
      700: "#006B99",
      800: "#004766",
      900: "#002433",
    },
    cyan: {
      50: "#E9F7FC",
      100: "#C0E8F7",
      200: "#98D9F1",
      300: "#6FCAEC",
      400: "#47BBE6",
      500: "#1EACE1",
      600: "#188AB4",
      700: "#126787",
      800: "#0C455A",
      900: "#06222D",
    },
  },
};

export default colors;
